import {runElectronFunc} from "./comm";

const showMenuKyowonPhoneDial = () => {
    return runElectronFunc('ElectronIptApi', 'showMenuKyowonPhoneDial');
}

const iptGateway = (props) => {
    return runElectronFunc('ElectronIptApi', 'iptGateway', props);
}

export {
    showMenuKyowonPhoneDial,
    iptGateway,
};
